module.exports = __webpack_public_path__ + "img/20200613_140426.ada9244d.jpg";